import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, ShieldAlert, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Magic-link handler for onboarding. Reads ?email=X&token=Y, calls
 * /auth/magic-verify, stores the token, then jumps to /onboarding.
 */
export default function OnboardingVerify() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState(null);
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    const email = params.get("email");
    const token = params.get("token");
    if (!email || !token) { setError("Missing verification parameters"); setStatus("error"); return; }
    (async () => {
      try {
        const r = await axios.post(`${API}/auth/magic-verify`, { email, token });
        localStorage.setItem("access_token", r.data.access_token);
        localStorage.setItem("token", r.data.access_token);
        try { await refresh?.(); } catch {}
        setStatus("ok");
        setTimeout(() => nav("/onboarding", { replace: true }), 800);
      } catch (e) {
        setError(e?.response?.data?.detail || "Link expired");
        setStatus("error");
      }
    })();
  }, [params, nav, refresh]);

  return (
    <div className="min-h-screen bg-[#070707] text-[#F5F5F0] grid place-items-center px-6">
      <div className="max-w-md text-center border border-[#B87333]/40 rounded-sm p-10 bg-white/[0.02]"
        style={{ boxShadow: "inset 0 0 80px rgba(184,115,51,0.10)" }}>
        {status === "verifying" && (
          <>
            <Loader2 className="w-10 h-10 text-[#B87333] mx-auto animate-spin mb-4" />
            <div className="overline text-[#B87333] mb-2">Vinci Registry</div>
            <div className="font-serif text-2xl">Opening your file…</div>
          </>
        )}
        {status === "ok" && (
          <>
            <ShieldCheck className="w-10 h-10 text-[#2FB999] mx-auto mb-4" />
            <div className="overline text-[#2FB999] mb-2">Verified</div>
            <div className="font-serif text-2xl">Welcome back</div>
            <div className="text-xs text-[#8A8A82] mt-2">Redirecting to the master form…</div>
          </>
        )}
        {status === "error" && (
          <>
            <ShieldAlert className="w-10 h-10 text-[#C0392B] mx-auto mb-4" />
            <div className="overline text-[#C0392B] mb-2">Link Invalid</div>
            <div className="font-serif text-2xl">This link expired</div>
            <div className="text-xs text-[#8A8A82] mt-2">{error}</div>
            <button onClick={() => nav("/")} className="mt-6 rounded-full border border-white/20 px-5 py-2 text-xs uppercase tracking-[0.2em] font-grotesk hover:border-[#B87333]">
              Back to Home
            </button>
          </>
        )}
      </div>
    </div>
  );
}
